module.exports = __webpack_public_path__ + "static/media/badge_supporting_1.5f3d8e44.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/badges/badge_supporting_1.png
// module id = 225
// module chunks = 0